<script>
	import { 
		mailLocacao, 
		mailVendas, 
		linkWhatsappLocacao,
		linkWhatsappVendas,
		alt 	
	} from '../store.js';
	import { Router, link, navigate }       from "svelte-routing";
	import { beforeUpdate, afterUpdate }    from 'svelte';

	import CardImovel           from './../components/CardImovel.svelte';
	import BarraCaracteristicas from './../components/BarraCaracteristicas.svelte';
	import CaracteristicaItem   from './../components/BarraCaracteristicas__Item.svelte';
	import GaleriaHero          from './../components/GaleriaHero.svelte';
	import Thumbs               from './../components/Thumbs.svelte';
	import LightGallery         from './../components/LightGallery.svelte';
	import Forms                from './../components/Forms.svelte';
	import Features             from './../components/Features.svelte';
	import Share                from './../components/Share.svelte';

	export let nt;
	export let id;
	export let shareCallback = false;
	let adressLine = '';

	let negotiationType = nt === 'Locação' ? atria.rent : atria.sell;
	let showMap = false;

	async function getRealty(nt, id) {
		let url = `${atria.mainURL}/Services/RealEstate/JSONP/List.aspx?mode=realty&callback=null&`;
		url += Object.entries({nt:negotiationType, ri:id}).map(e=>`${e[0]}=${e[1]}`).join('&');
		let response = await fetch(url,{
			method: 'GET',
			mode: 'cors'
		});
		let data = await response.json()
		return data;
	}

	async function getNeighbors(nt, id) {
		let url = `${atria.mainURL}/Services/RealEstate/JSONP/List.aspx?mode=neighbors&callback=null&`;
		url += Object.entries({
			nt: negotiationType, 
			ri: id,
			minPercent: 20,
			maxPercent: 20,
			pageSize: 6
			}).map(e=>`${e[0]}=${e[1]}`).join('&');
		let response = await fetch(url,{
			method: 'GET',
			mode: 'cors'
		});
		let data = await response.json()
		return data;
	}

	let realty = null;
	$: neighbors = [];

	getRealty(nt, id).then(json => {
		if (json.Error) {
			navigate("/oops", { replace: true });
		}

		realty = json.Items[0];
		fields = getFields();
		message = getMessage();
		subject = getSubject();
		destinyContato = getDestiny();
		whatsappCall = getWhatsappCall();
		titlePage = getTitlePage();
		adressLine = getAdressLine();
		showSohtec = getSohtec();

		if (shareCallback) {
			navigate(document.location.pathname.replace('/go-imovel/', '/imovel/'), {replace:true});
		}
	});

	getNeighbors(nt, id).then(njson => {
		if (!njson.Error) {
			neighbors = njson.Items;
		}            
	});

	function getAdressLine(){

		if (realty.CurrentNegotiationTypeId == atria.rent)
			return `<span style="text-transform:capitalize;">${realty.CurrentSpot.CurrentAddress.toLowerCase()}</span>, ${realty.CurrentSpot.Number}, ${realty.CurrentSpot.Neighborhood} - ${realty.CurrentSpot.City}`;
		else
			return `<span style="text-transform:capitalize;">${realty.CurrentSpot.CurrentAddress.toLowerCase()}</span>, ${realty.CurrentSpot.Neighborhood} - ${realty.CurrentSpot.City}`;

	}
	
	function sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}
	
	function openMap() {
		showMap = true;
	}
	
	function getMapURL() {
		if (realty != null && realty.CurrentSpot != null && realty.CurrentSpot.Latitude != 0 && realty.CurrentSpot.Longitude != 0) {
			return `https://maps.google.com/maps?q=${realty.CurrentSpot.Latitude},${realty.CurrentSpot.Longitude}&t=&z=18&ie=UTF8&iwloc=&output=embed`;
		} else if (realty != null && realty.CurrentSpot != null && realty.CurrentSpot.CurrentAddress != '') {
			return `https://maps.google.com/maps?q=${realty.CurrentSpot.CurrentAddress},${realty.CurrentSpot.Number} - ${realty.CurrentSpot.City}&t=&z=18&ie=UTF8&iwloc=&output=embed`;
		} else {
			return '';
		}
	}
	
	// Mail Box Contato
	function getFields() {
		return [
			{
				title:  'Nome *',
				name:   'nome',
				required:   'required',
				showLabel: false,
			},
			{
				title:  'Telefone *',
				name:   'telefone',
				required: 'required',
				showLabel: false,
			},
			{
				title:  'Email *',
				name:   'email',
				type: 'email',
				required: 'required',
				showLabel: false,
			},
			{
				title:      'Mensagem *',
				name:       'mensagem',
				showLabel:  false,
				required:   'required',
				type:       'textarea',
				defaultValue:  realty != null ? `Solicito maiores detalhes sobre o imóvel COD ${realty.ReferenceId} - ${realty.CurrentRealtyTypeTitle} para ${realty.CurrentNegotiationTypeTitle}.` : "",
				rows: 4
			}
		];        
	}

	// Mail Box Mensagem
	function getMessage() {

		if (realty == null) {
			return '';
		}

		return `
			Nome: {nome}
			Telefone: {telefone}
			Email: {email}
			Imóvel: ${realty.ReferenceId} - ${realty.CurrentRealtyTypeTitle}
			Interesse: ${realty.CurrentNegotiationTypeTitle}
			Mensagem: {mensagem}
			
			{info}
		`;
	}

	// Mail Box Assunto
	function getSubject() {

		if (realty == null) {
			return '';
		}

		return `Imóvel ${realty.ReferenceId} | ${realty.CurrentNegotiationTypeTitle} | Contato`;
}

	$: subject = getSubject();
	$: message = getMessage();
	$: fields = getFields();

	// WhatsApp
	function getWhatsappCall() {
		let whatsappMailBox = "";
		
		if (realty != null){

			if (realty.CurrentNegotiationTypeId == atria.rent)
				whatsappMailBox = $linkWhatsappLocacao;
			else
				whatsappMailBox = $linkWhatsappVendas;
			
			return `https://api.whatsapp.com/send?phone=${whatsappMailBox}&text=Solicito mais detalhes sobre o imóvel COD ${realty.ReferenceId} - ${realty.CurrentRealtyTypeTitle} para ${realty.CurrentNegotiationTypeTitle}.`
		}
		return "";
	}

	$: whatsappCall = getWhatsappCall();

	// Título Página
	function getTitlePage() {
		if (realty != null){
			return `${realty.Title} para ${realty.CurrentNegotiationTypeTitle} em ${realty.CurrentSpot.Neighborhood}, ${realty.CurrentSpot.City} | ${$alt}`;
		}
		return "";
	}

	$: titlePage = getTitlePage();

	// Destino Contato
	function getDestiny() {
		if (realty != null){
			if (realty.CurrentNegotiationTypeId == atria.sell){
				console.log("Mail box Vendas");
				return $mailVendas;
			}else{
				console.log("Mail box Locação");
				return $mailLocacao;
			}
		}
	}

	$: destinyContato = getDestiny();    

  	//Carrega bookmarks
	atria.loadBookmarks();

	let favoritar = { 
		favorito: atria.hasBookmark(negotiationType, id)
	};

	function toggleBookmarks() {
		if (atria.hasBookmark(negotiationType, id)) {
			atria.removeBookmark(negotiationType, id);
		} else {
			atria.addBookmark(negotiationType, id);
		}

		favoritar.favorito = !favoritar.favorito;
	}

	// Galeria
	let selectedPhotoIndex = null;
	function openGallery(event) {
		selectedPhotoIndex = event.detail.pos;
	}
	function getSohtec() {
		if (realty == null || realty.CurrentNegotiationTypeId != atria.rent) {
			return null;
		}

		return true;
	}
	function goToSohtec() {
		let param = {
			"customHTML": "", //Opcional (Informe aqui o seu html customizado para o botão)
			"buttonColorBg": "blue",
			"clienteId": "245",
			"modulo": "LOCACAO",
			"imovelId": realty.ReferenceId,
			"imovelUrl": realty.Image,//document.location.toString(), //Informe a URL Absoluta da imagem (Ex: http://www.seudominio.com.br/imagem.jpg)
			"imovelEndereco": realty.CurrentSpot.CurrentAddress,
			"imovelNumero": realty.CurrentSpot.Number,
			"imovelComplemento": "",
			"imovelBairro": realty.CurrentSpot.Neighborhood,
			"imovelCidade": realty.CurrentSpot.City,
			"imovelEstado": realty.CurrentSpot.CurrentStateName,
			"imovelDormitorios": realty.Bedrooms,
			"imovelVagas": realty.ParkingSpots,
			"imovelCep": realty.CurrentSpot.ZipCode,
            "imovelAluguel": realty.FormattedPrice,
            "imovelCondominio": realty.FormattedCondominiumValue,
            "imovelIptu": realty.FormattedIPTUValue,
			"visitaAcompanhada": realty.Promotion02 == '1' ? "true" : "false"
		};

		SOH.Post(encodeURIComponent(JSON.stringify(param)));

	}
	$: showSohtec = getSohtec();
</script>

<svelte:head>
	<title>{titlePage}</title>
</svelte:head>

{#if !shareCallback}
	{#if realty === null}
		<div class="container pt-30 loading">
			<div class="row">        
				<section class="col-lg-8 imovel-detail">
					<div class="imovel-infos">
						<h1 class="title"><span class="loading-text" style="max-width:250px;height:35px;"></span></h1>
						<p><span class="loading-text" style="max-width:350px;height:28px;"></span></p>
					</div>
					<div class="imovel-fotos">
						<ul class="imovel-galeria">
							<li class="item">
								<span class="loading-img" style="height: 470px;"></span>
							</li>
						</ul>
					</div>
					<div class="imovel-descricao mt-20">
						<p class="text-justify"></p>
					</div>
				</section>
				<section class="col-lg-4 imovel-box-infos"> 
					<div class="box-sticky">
						<div class="card">
							<div class="price-infos">
								<ul>
									<li class="mb-10"> 
										<span class="loading-text" style="max-width:350px;height:28px;"></span>
									</li>
									<li class="mb-10"> 
										<span class="loading-text" style="max-width:350px;height:28px;"></span>
									</li>
									<li class="total" style="margin-bottom:10px">
										<span class="loading-text" style="max-width:350px;height:28px;"></span>
									</li>
								</ul>
							</div>

							<div class="contato mb-10">
								<div class="form-group">
									<span class="loading-text" style="height:35px;"></span>
								</div>
								<div class="form-group">
									<span class="loading-text" style="height:35px;"></span>
								</div>
								<div class="form-group">
									<span class="loading-text" style="height:35px;"></span>
								</div>
								<div class="form-group">
									<span class="loading-text" style="height:100px;"></span>
								</div>
								<div class="text-right">
									<span class="loading-text" style="max-width:100px;height:35px;"></span>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	{:else}
		<GaleriaHero realty={realty} gallery={realty.Photos} on:viewPhoto={openGallery}>
			<span slot="dock-left">
				<a class="btn-link-white" href="javascript:void(0);" on:click={() => scrollTo('.imovel-mapa')}>
					<i class="fad fa-map-pin icon-transform mr-2"></i> 
					{@html adressLine}
				</a>        
			</span>
			<span slot="dock-right">
				<a class="pr-1" href="javascript:void(0)" on:click={() => scrollTo('.imovel-infos .title')} title="Saiba Mais">
					<i class="icon-transform color-white fas fa-chevron-down"></i>
				</a>
				<a class="pr-2" href="javascript:void(0)" on:click={() => scrollTo('.contato')} title="Entre em Contato">
					<i class="icon-transform color-white fas fa-envelope"></i>
				</a>
				{#if realty.Photos.length > 0}
					<a class="pr-2" href="javascript:void(0)" on:click={() => scrollTo('.imovel-photos')} title="Veja mais fotos">
						<i class="icon-transform color-white fas fa-images"></i>
					</a>
				{/if}
				<Share/>
				{#if favoritar.favorito}
					<a class="pr-2" href="javascript:void(0)" title="Remover dos Favoritos" on:click={toggleBookmarks}>
						<i class="icon-transform color-tomato fas fa-heart"></i>
					</a>
				{:else}
					<a class="pr-2" href="javascript:void(0)" title="Adicionar aos Favoritos" on:click={toggleBookmarks}>
						<i class="icon-transform color-tomato far fa-heart"></i>
					</a>            
				{/if}
			</span>
		</GaleriaHero>
		<LightGallery gallery={realty.Photos} selectedPhotoIndex={selectedPhotoIndex} />
		<div class="container pt-10">
			<div class="row">
				<section class="col-lg-8 imovel-detail">
					<div class="imovel-infos">
						<h1 class="title color-primary"><b>{realty.CurrentRealtyTypeTitle} para {realty.CurrentNegotiationTypeTitle}</b></h1>
						<p>{@html adressLine}</p>
					</div>
					<div class="imovel-descricao mt-20">
						<p class="text-justify">
							{@html realty.Description}
						</p>
					</div>
					<div class="imovel-caracteristicas mt-30">
						<BarraCaracteristicas realty={realty} />
					</div>
					{#if realty.RealtyFieldItems.length > 0}
						<div class="imovel-features mt-30">
							<h2 class="title mb-20"><b><i class="fas fa-star color-primary"></i> Características</b></h2>
							<Features realty={realty}/>
						</div>
					{/if}
					{#if realty.Photos.length > 0}
						<div class="imovel-photos mt-30">
							<h2 class="title mb-20"><b><i class="fas fa-images color-primary"></i> Fotos</b></h2>
							<Thumbs gallery={realty.Photos} on:viewPhoto={openGallery}/>
						</div>
					{/if}
					{#if realty.Video != null }
					<div class="imovel-video mt-30">
						<h2 class="title mb-20"><b><i class="fab fa-youtube color-primary"></i> Vídeo</b></h2>
						<iframe style="width: 100%; height: 450px" src="https://www.youtube.com/embed/{realty.Video}?controls=1&rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					</div>
					{/if}
					{#if realty.YouTubeVideos != null && realty.YouTubeVideos.length == 1 }
					<div class="imovel-video mt-30">
						<h2 class="title mb-20"><b><i class="fab fa-youtube color-primary"></i> Vídeo</b></h2>
						<iframe style="width: 100%; height: 450px" src="https://www.youtube.com/embed/{realty.YouTubeVideos[0].Code}?controls=1&rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					</div>
					{/if}
				</section>
				<section class="imovel-box-infos col-lg-4">
					<div class="box-sticky">
						{#if favoritar.favorito}
							<a class="btn btn-rounded btn-primary w-100 mt-10" href="#" on:click={toggleBookmarks}>
								<i class="fas fa-heart"></i> 
								Remover dos Favoritos 
							</a>
						{:else}
							<a class="btn btn-rounded btn-primary w-100 mt-10" href="#" on:click={toggleBookmarks}>
								<i class="far fa-heart"></i> 
								Adicionar aos Favoritos 
							</a>                        
						{/if}
						{#if realty.CurrentNegotiationTypeId == atria.rent}
							<a tabindex="0" href="https://outlook.office365.com/owa/calendar/CalendrioLocao@spimobiliaria.com.br/bookings/" target="_blank" class="btn btn-primary btn-rounded w-100 mt-10 mb-10">Agendar visita</a>
						{/if}						
						{#if showSohtec != null}
							<a style="display: none;" tabindex="0" on:click="{goToSohtec}" class="btn btn-primary btn-rounded w-100 mt-10 mb-10">Agendar visita</a>
							<a style="display: none;" tabindex="1" on:click="{goToSohtec}" class="btn btn-primary btn-rounded w-100 mb-10">Faça uma proposta</a>
							<a style="display: none;" tabindex="2" on:click="{goToSohtec}" class="btn btn-primary btn-rounded w-100">Alugue online</a>
						{/if}
						<div class="card mt-20">
							<div class="price-infos">
								<ul>
									{#if realty.ShowPrice}
									<li class=""> 
										{#if realty.CurrentNegotiationTypeId === '-3'}
										<h3><b>Aluguel Mensal</b></h3>
										{:else}
										<h3><b>Valor</b></h3>
										{/if}
										<p class="value"><b>R$ {realty.FormattedPrice}</b></p>
									</li>
									{:else}
									<li class=""> 
										{#if realty.CurrentNegotiationTypeId === '-3'}
										<h3><b>Aluguel Mensal</b></h3>
										{:else}
										<h3><b>Valor</b></h3>
										{/if}
										<p class="value"><b>Sob Consulta</b></p>
									</li>
									{/if}
									{#if realty.CondominiumValue > 0}
									<li>
										<h3>Condomínio</h3>
										<p class="value">R$ {realty.FormattedCondominiumValue}</p>
									</li>
									{/if}
									{#if realty.IPTUValue > 0}
									<li>
										<h3>IPTU</h3>
										<p class="value">R$ {realty.FormattedIPTUValue}</p>
									</li>
									{/if}
									{#if realty.ShowPrice && realty.CurrentNegotiationTypeId === '-3' && (realty.IPTUValue > 0 || realty.CondominiumValue > 0)}
									<li class="total">
										<h3><b>Total</b></h3>
										<p class="value"><b>R$ {realty.FormattedFullPrice}</b></p>                            
									</li>
									{/if}
								</ul>
							</div>
							<div class="contato mb-10">
								<h3 class="color-primary mb-20"><b>Entre em contato e saiba mais:</b></h3>
								<Forms boxContato={true} destiny={destinyContato} fields={fields} subjectTitle={subject} {message} htmlbody={false} />
							</div>
							<div class="buttons">
								<a href="{whatsappCall}" target="_blank" class="btn btn-primary btn-whatsapp btn-rounded bg-whatsapp w-100"><i class="fab fa-whatsapp"></i> Falar via WhatsApp</a>
							</div>
						</div>
					</div>
				</section>
				<section class="imovel-mapa mt-20 col-md-12">
					<div class="row">
						<h2 class="col col-md-6 title mb-20"><b><i class="fas fa-map-marked color-primary"></i> Mapa</b></h2>
						<p class="col-md-6 text-md-right">{@html adressLine}</p>   
					</div>
					{#if showMap}
						<div class="mapa open">                   
							<div class="holder">
								<iframe style="width:100%;" height="500" id="gmap_canvas" src="{getMapURL()}" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
							</div>
						</div>
					{:else}
						<div class="mapa">
							<div class="holder">
								<img class="toggle img-fluid" src="/assets/images/imgToqueMapa.png" alt="Carregar mapa" on:click={openMap} />
							</div>
						</div>
					{/if}
				</section>
			</div>
		</div>
		{#if neighbors.length > 0}
			<!-- Imóveis semelhantes -->
			<section class="imoveis-semelhantes mt-30">
				<div class="container">
					<h3 class="text-center"><b>Imóveis <span class="color-primary">semelhantes</span></b></h3>
					<div class="mt-30">
						<div class="row imoveis">
							{#each neighbors as imovel}
								<div class="col-xs-12 col-md-6 col-lg-4 mb-20">
									<CardImovel realty={imovel} />
								</div>
							{:else}
								<div class="col">
									<p>Nenhum imóvel encontrado.</p>
								</div>
							{/each}
						</div>
					</div>
				</div>
			</section>
		{/if}
	{/if}
{/if}

<style type="text/sass">

@import 'public/assets/sass/variables.sass'

.title
	font-size: $font-text--large

.breadcrumb
	background-color: transparent
	padding: 10px 0
	a
		color: $color-secondary

#imovel-galeria 
	padding: 0
	border-radius: 5px
	overflow: hidden
	img  
		object-fit: cover 
		width: 100%
		cursor: pointer
		
.imovel-infos 
	h1 
		font-size: $font-title 
	p 
		font-size: $font-text
		color: $color-font-primary

.imovel-features 
	margin-bottom: 20px

.card 
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3)
	border-radius: 5px
	padding: 25px 20px

.imovel-box-infos    
	background-color: #fff
	text-align: center
	
.price-infos
	ul 
		background-color: transparent
		margin: 0px 0 20px 0
		padding: 0px
		list-style: none
		li 
			display: flex
			align-items: center
			justify-content: space-between
			&.total 
				border-top: 1px dotted $color-border
				margin-top: 10px 
				padding-top: 10px
			h3, p 
				font-size: $font-text
				margin: 0

.contato
	h3 
		font-size: $font-text
		font-weight: 500
	.form-control 
		width: 100%

.box-sticky 
	width: 100%
	position: sticky
	top: 40px
	margin: 0px

.imovel-mapa .mapa
	.holder
		border-radius: 5px
		cursor: pointer
		background-image: url(/assets/images/mapa.jpg)
		background-position: center
		background-size: cover
		text-align: center
		height: 500px
		width: 100%
		iframe
			border-radius: 5px
	.toggle
		margin: 115px 0
		padding: 0px
		box-shadow: 0 0 5px #CCC
	&.open
		.holder
			background-image: none
			padding: 0px
			background: linear-gradient(89deg, #F8F9FA, #cccccc)
			background-size: 400% 400%
			-webkit-animation: loading-background 2s ease infinite
			-moz-animation: loading-background 2s ease infinite
			animation: loading-background 2s ease infinite

.imoveis-semelhantes
	padding-top: 20px
	
</style>